<template>
  <div class="wrapper" style="overflow:hidden">
    <el-carousel trigger="click" :interval="5000" style="height:100vh">
      <el-carousel-item
        v-for="item in carousel"
        :key="item.image"
        style="height:100vh;"
      >
        <div class="carousel-center">
          <h2>{{ item.caption }}</h2>
          <h1 style="font-size:72px; font-weight:bold">{{ item.title }}</h1>
          <md-button
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            class="md-primary md-sm"
            target="_blank"
          >
            <i class="fas fa-play" /> Watch video
          </md-button>
        </div>

        <div class="full-carousel-image darkened">
          <img :src="item.image" :alt="image.title" />
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="section section-features-1 pt-0">
            <div class="container">
              <div class="md-layout md-alignment-center">
                <!-- Services Items Start -->
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                  v-for="(service, index) in services"
                  :key="index"
                >
                  <info-areas info-horizontal icon-color="info" icon="airplay">
                    <h4 slot="title" class="info-title">{{ service.title }}</h4>
                    <div slot="content" class="description">
                      <p>{{ service.description }}</p>
                      <a href="javascript:void(0)">Find more...</a>
                    </div>
                  </info-areas>
                  <!-- Services Items End -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- About us starts -->

        <div class="md-layout md-alignment-center" style="flex-wrap: nowrap;">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <img :src="whatSetsUsApart.left.image" />
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100 text-center">
            <h3 class="whatSetsUsApart-content">
              {{ whatSetsUsApart.middle.title }}
            </h3>
            <p class="whatSetsUsApart-content">
              {{ whatSetsUsApart.middle.info }}
            </p>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100" style>
            <img :src="whatSetsUsApart.left.image" style />
          </div>
        </div>

        <!-- About us ends -->

        <!-- What sets us apart start -->

        <!-- Features 5 -->
        <div class>
          <div class="md-layout" style="margin-left:0; margin-right:0;">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h2 class="title">What makes us different</h2>
            </div>
          </div>

          <!-- Layout begins -->
          <div
            class="md-layout"
            style="margin-left:0; margin-right:0; background-color: whitesmoke;"
          >
            <!-- Left slide -->
            <div
              class="md-layout-item md-size-32 md-small-size-100"
              style="height: 80vh; padding:0;"
            >
              <div class="md-layout" style="margin-left:0; margin-right:0;  ">
                <!-- Left top -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                  style="height: 40vh; padding: 0"
                >
                  <img
                    :src="whatSetsUsApart.left.image"
                    style="height: 40vh; width: 100%"
                  />
                </div>
                <!-- Left bottom -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100"
                  style="height: 40vh"
                >
                  <div class="text-center whatSetsUsApart-container">
                    <h3 class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.left.title }}
                    </h3>
                    <p class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.left.info }}
                    </p>
                  </div>
                  <md-divider
                    style="background-color: midnightblue; height:1px; margin-left: 40%; margin-right:40%; width: auto;"
                  ></md-divider>
                </div>
              </div>
            </div>

            <!-- Middle slide -->
            <div
              class="md-layout-item md-size-32 md-small-size-100"
              style="background-color: whitesmoke; height: 80vh; padding:0;"
            >
              <div class="md-layout" style="margin-left:0; margin-right:0;  ">
                <!-- Middle top -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100"
                  style="height: 40vh"
                >
                  <div class="text-center whatSetsUsApart-container">
                    <h3 class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.middle.title }}
                    </h3>
                    <p class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.middle.info }}
                    </p>
                  </div>
                  <md-divider
                    style="background-color: midnightblue; height:1px; margin-left: 40%; margin-right:40%; width: auto;"
                  ></md-divider>
                </div>
                <!-- Middle bottom -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                  style="height: 40vh; padding: 0"
                >
                  <img
                    :src="whatSetsUsApart.middle.image"
                    style="height: 40vh; width: 100%"
                  />
                </div>
              </div>
            </div>

            <!-- Right slide -->
            <div
              class="md-layout-item md-size-32 md-small-size-100"
              style="height: 80vh; padding:0;"
            >
              <div class="md-layout" style="margin-left:0; margin-right:0;  ">
                <!-- Right top -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                  style="height: 40vh; padding: 0"
                >
                  <img
                    :src="whatSetsUsApart.right.image"
                    style="height: 40vh; width: 100%"
                  />
                </div>
                <!-- Right bottom -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100"
                  style="height: 40vh"
                >
                  <div class="text-center whatSetsUsApart-container">
                    <h3 class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.right.title }}
                    </h3>
                    <p class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.right.info }}
                    </p>
                  </div>
                  <md-divider
                    style="background-color: midnightblue; height:1px; margin-left: 40%; margin-right:40%; width: auto;"
                  ></md-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- What sets us apart end -->

        <!-- Clients start -->

        <agile :options="clients.options">
          <div class="md-layout md-alignment-center"></div>
        </agile>

        <!-- Clients End -->

        <!-- Portfolio tabs start -->
        <div class="md-layout section">
          <div
            class="md-layout-item md-size-100 md-small-size-100"
            style="padding-right:0; padding-left: 0;"
          >
            <tabs
              :tab-active="1"
              :tab-name="serviceList"
              :tab-icon="['dashboard', 'schedule', 'list']"
              plain
              nav-pills
              color-button="primary"
              pillsAlign="center"
            >
              <!-- here you can add your content for tab-content -->

              <!-- Slot 1 starts -->
              <div slot="tab-pane-1">
                <masonry :cols="{ default: 3, 700: 2, 400: 1 }" :gutter="5">
                  <div v-for="(item, index) in portfolio.wallart" :key="index">
                    <div class="portfolio-container" style="margin-bottom: 5px;">
                      <img :src="item.image" :alt="item.title" />
                      <div class="portfolio-overlay">
                        <md-divider class="portfolio-divider"></md-divider>
                        <h3 class="portfolio-title">{{ item.title }}</h3>
                        <h5 class="portfolio-caption">{{ item.text }}</h5>
                      </div>
                    </div>
                  </div>
                </masonry>
              </div>
              <!-- Slot 1 ends -->
            </tabs>
          </div>
        </div>
        <!-- Portfolio end -->

        <!-- TODO Connect this to scroll event -->

        <!-- Counters begin -->
        <div
          class="md-layout md-alignment-center"
          style="margin-right: 20vw; margin-left:20vw; margin-top: 0;"
        >
          <div
            class="md-layout-item"
            v-for="(counter, index) in counters"
            :key="index"
          >
            <info-areas info-horizontal icon-color="info" icon="airplay">
              <h2 slot="title" style="margin-bottom: 0;">
                <countTo
                  :startVal="counter.start"
                  :endVal="counter.end"
                  :duration="counterDuration"
                ></countTo>
              </h2>
              <h3 slot="content" style="margin-top: 0;">{{ counter.title }}</h3>
            </info-areas>
          </div>
        </div>
        <!-- Counters end -->

        <!-- Testimonials Begin -->

        <!-- https://element.eleme.io/?ref=madewithvuejs.com#/en-US/component/carousel -->

        <div class="section section-testimonials-2 section-dark">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <el-carousel
                  indicator-position="outside"
                  arrow="never"
                  trigger="click"
                  :interval="5000"
                >
                  <el-carousel-item>
                    <testimonial-card card-plain>
                      <div slot="cardAvatarTop" class="md-card-avatar mt-0">
                        <a href="javascript:void(0)">
                          <img class="img" :src="cardProfile3.cardProfile1" />
                        </a>
                      </div>
                      <template slot="cardContent">
                        <h5 class="card-description">
                          "I speak yell scream directly at the old guard on
                          behalf of the future. I gotta say at that time I’d
                          like to meet Kanye I speak yell scream directly at the
                          old guard on behalf of the future. My brother
                          Chance!!!
                          <br />Thank you for letting me work on this
                          masterpiece. One of my favorite people."
                        </h5>
                        <h4 class="card-title">Kendall Thompson</h4>
                        <h6 class="card-category text-muted">
                          CEO @ Marketing Digital Ltd.
                        </h6>
                      </template>
                    </testimonial-card>
                  </el-carousel-item>
                  <el-carousel-item>
                    <testimonial-card card-plain>
                      <div slot="cardAvatarTop" class="md-card-avatar mt-0">
                        <a href="javascript:void(0)">
                          <img class="img" :src="cardProfile3.cardProfile2" />
                        </a>
                      </div>
                      <template slot="cardContent">
                        <h5 class="card-description">
                          "Thank you Anna for the invite thank you to the whole
                          Vogue team Called I Miss the Old Kanye At the God's
                          last game Chop up the soul Kanye. I promise I will
                          never let the people down. I want a better life for
                          all!!! Pablo Pablo Pablo Pablo! Thank you Anna for the
                          invite thank you to the whole Vogue team."
                        </h5>
                        <h4 class="card-title">Christian Louboutin</h4>
                        <h6 class="card-category text-muted">
                          Designer @ Louboutin &amp; Co.
                        </h6>
                      </template>
                    </testimonial-card>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
        <!--Testimonials End -->
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { Tabs, InfoAreas, TestimonialCard } from "@/components";
import { VueAgile } from "vue-agile";
import countTo from "vue-count-to";

export default {
  components: {
    Tabs,
    InfoAreas,
    agile: VueAgile,
    countTo,
    TestimonialCard
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      image: require("@/assets/img/landing-illustration.jpg"),
      services: [
        {
          title: "Spotlight Scouts",
          description: `To fuel your E-Business strategy, we provide a web of customized solutions.  `
        },
        {
          title: "Epoxy Resin furniture",
          description: `An elegant and glossy finish for your furnishing.  `
        },
        {
          title: "Snehin (Hand-printed Fabrics)",
          description: `Striving to deliver fabricated bliss to transform every Woman’s life! `
        },
        {
          title: "Wall Art, Murals, Graffiti",
          description: `Fabricated artwork solutions to reshape your outdoor advertising! `
        },
        {
          title: "Interior Design",
          description: ` Let our eye for detail inhabit your mind’s space!  `
        },
        {
          title: "Art Workshops",
          description: ` We’re branching out to nurture the tricks of OUR trade-in you!  `
        }
      ],
      serviceList: [
        "Wall art",
        "Spotlight Scouts",
        "Snehin",
        "Epoxy",
        "Workshops"
      ],
      name: null,
      email: null,
      message: null,
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
        cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
      },
      whatSetsUsApart: {
        left: {
          title: "True and Unique",
          info: `We at Artysan believe in the truth our colours present to the world. Trusting our creative flair, we look forward to displaying our unique arts through different media. Every art piece we make is distinct to suit your requirements.`,
          image: require("@/assets/img/nature-2.jpg")
        },
        middle: {
          title: "Customised Solutions",
          info: `We have done it all from hand-painted walls to the customised details of your saree pallu. We have the potential to live your dreams on the canvass. We customise art as per your recommendations.`,
          image: require("@/assets/img/nature.jpg")
        },
        right: {
          title: "Proficient and Efficient",
          info: `With our talented, proficient and efficient members, we aim to deliver high-quality products and services to you. Our customers always come first. `,
          image: require("@/assets/img/nature-3.jpg")
        }
      },
      clients: {
        options: {
          autoplay: true,
          centerMode: true,
          dots: false,
          navButtons: false,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1000,
              settings: {
                navButtons: true
              }
            }
          ]
        },
        icons: []
      },
      portfolio: {
        wallart: [
            {
              image: require("@/assets/img/landing/portfolio/wallart/1.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/2.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/3.jpeg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/4.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/5.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/6.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/7.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/8.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/9.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/10.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/11.png"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/12.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            }
          ]
      },

      counterDuration: 3000,
      counters: [
        {
          start: 0,
          end: 1000,
          title: "Spaces Embellished "
        },
        {
          start: 0,
          end: 3000,
          title: "Gratified Clients"
        },
        {
          start: 0,
          end: 3000,
          title: "Weeks doing Business"
        },
        {
          start: 0,
          end: 3000,
          title: "Hours Invested "
        }
      ],
      carousel: [
        {
          image: require("@/assets/img/home-carousel/1.jpg"),
          title: "Curated Aesthetics to Match your Vision!",
          caption: "We Aspire to Inspire"
        },
        {
          image: require("@/assets/img/home-carousel/2.jpg"),
          title: "Tailored Deliverables at your Fingertips!",
          caption: "We Provide Refined Options"
        },
        {
          image: require("@/assets/img/home-carousel/3.jpg"),
          title: "Embark on this Vivid Experience with us!",
          caption: "We’re a Team of Passionate Members"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
